var Footer = $.extend({/* Footer */}, BaseComponent, {

	componentSelector: 'footer-component'
})